// mypreset.ts
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const Nt25Preset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#e0f7f6',
      100: '#b3ecea',
      200: '#80e0dd',
      300: '#4dd4d0',
      400: '#26c9c4',
      500: '#19a8a2', // main color
      600: '#13817c',
      700: '#0e5a56',
      800: '#093330',
      900: '#041a18',
      950: '#02100e'
    }
  }
});

export default Nt25Preset;
